import { GET_PUBLISHED_VERSIONS } from './versions.types';

export const getPublishedVersions = () => {
    return {
        type: GET_PUBLISHED_VERSIONS,
    };
};
